import { createThunkEffect } from "../../utilities/ActionUtility";
import * as AdminGroupEffect from "./AdminGroupEffect";

export const REQUEST_ALL_ADMIN_GROUPS = "AdminGroupEffect.REQUEST_ALL_ADMIN_GROUPS";
export const REQUEST_ALL_ADMIN_GROUPS_FINISHED = "AdminGroupEffect.REQUEST_ALL_ADMIN_GROUPS_FINISHED";

export function requestAllAdminGroups() {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_ADMIN_GROUPS, AdminGroupEffect.requestAllAdminGroups);
    };
}

export const REQUEST_ADMIN_GROUP_USERS = "AdminGroupEffect.REQUEST_ADMIN_GROUP_USERS";
export const REQUEST_ADMIN_GROUP_USERS_FINISHED = "AdminGroupEffect.REQUEST_ADMIN_GROUP_USERS_FINISHED";

export function requestAdminGroupUsers(adminGroupId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ADMIN_GROUP_USERS, AdminGroupEffect.requestAdminGroupUsers, adminGroupId);
    };
}

export const ADD_USER_TO_ADMIN_GROUP = "AdminGroupEffect.ADD_USER_TO_ADMIN_GROUP";
export const ADD_USER_TO_ADMIN_GROUP_FINISHED = "AdminGroupEffect.ADD_USER_TO_ADMIN_GROUP_FINISHED";

export function addUserToAdminGroup(adminGroupId, userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, ADD_USER_TO_ADMIN_GROUP, AdminGroupEffect.addUserToAdminGroup, adminGroupId, userId);
    };
}

export const DELETE_USER_FROM_ADMIN_GROUP = "AdminGroupEffect.DELETE_USER_FROM_ADMIN_GROUP";
export const DELETE_USER_FROM_ADMIN_GROUP_FINISHED = "AdminGroupEffect.DELETE_USER_FROM_ADMIN_GROUP_FINISHED";

export function deleteUserFromAdminGroup(adminGroupId, userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, DELETE_USER_FROM_ADMIN_GROUP, AdminGroupEffect.deleteUserFromAdminGroup, adminGroupId, userId);
    };
}
